import { CreateOrEditDeploymentFreeze } from "./CreateOrEditDeploymentFreeze";
interface EditDeploymentFreezePageProps {
    deploymentFreezeId: string;
}
export function EditDeploymentFreezePage({ deploymentFreezeId }: EditDeploymentFreezePageProps) {
    return <CreateOrEditDeploymentFreeze create={false} deploymentFreezeId={deploymentFreezeId}/>;
}
